import { forwardRef, type Ref, type SVGProps } from "react";
const IconThreeDimensionalOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 8 17 1.6a1.8 1.8 0 0 0-1-.2 1.8 1.8 0 0 0-1 .2L4 8a1.9 1.9 0 0 0-1 1.7v11.7a2 2 0 0 0 .9 1.7l11 7.2h.1l1 .2 1-.2h.1l11-7.2a2 2 0 0 0 .9-1.7V9.7A1.9 1.9 0 0 0 28 8M15 28 5 21.4V10.8l10 5.8zm1-13.1L6 9.1l10-5.7 10 5.7zm11 6.5L17 28V16.6l10-5.8z" />
  </svg>
);
const ForwardRef = forwardRef(IconThreeDimensionalOutlineSVG);
ForwardRef.displayName = "IconThreeDimensionalOutline";
export { ForwardRef as IconThreeDimensionalOutline };
